import { FolderOpen } from "lucide-react";

export default function PageSkeleton({ name = "Page" }: { name?: string }) {
  return (
    <div className="flex flex-col items-center justify-center h-full py-24 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mb-4">
        <FolderOpen className="w-8 h-8 text-gray-300" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900">{name}</h2>
      <p className="text-gray-500 mt-2 text-sm max-w-sm">
        This page is under construction. Check back soon!
      </p>
    </div>
  );
}
